import {Button, ButtonState} from '@fantasmagames/core/src/display/Button';
import {ResourcesLoader} from '@fantasmagames/core/src/loader/ResourcesLoader';

interface StateMap {
	[state: number]: PIXI.DisplayObject;
}

export class SpriteButton extends Button {
	constructor(callback?: Function) {
		super(callback);
		this.enable();
	}

	public setFramesNames(resources: ResourcesLoader, sheetName: string, up: string, down?: string, over?: string, disabled?: string): void {
		const buttonUp: PIXI.Sprite = new PIXI.Sprite(resources.getSpritesheetTexture(sheetName, up));
		const buttonDown: PIXI.Sprite = new PIXI.Sprite(resources.getSpritesheetTexture(sheetName, down ? down : up));
		const buttonOver: PIXI.Sprite = new PIXI.Sprite(resources.getSpritesheetTexture(sheetName, over ? over : up));
		const buttonDisabled: PIXI.Sprite = new PIXI.Sprite(resources.getSpritesheetTexture(sheetName, disabled ? disabled : up));

		buttonUp.anchor.set(0.5, 0.5);
		buttonDown.anchor.set(0.5, 0.5);
		buttonOver.anchor.set(0.5, 0.5);
		buttonDisabled.anchor.set(0.5, 0.5);

		this.setFrames(buttonUp, buttonDown, buttonOver, buttonDisabled);
	}

	public setFrames(up: PIXI.DisplayObject, down?: PIXI.DisplayObject, over?: PIXI.DisplayObject, disabled?: PIXI.DisplayObject): void {
		this._frames[ButtonState.UP] = up;
		this._frames[ButtonState.DOWN] = down ? down : up;
		this._frames[ButtonState.OVER] = over ? over : up;
		this._frames[ButtonState.DISABLED] = disabled ? disabled : up;

		this.updateFrame();
	}

	protected updateFrame(): void {
		if (this._frames[this._state]) {
			this.addChild(this._frames[this._state]);
		}
	}

	protected cleanFrame(): void {
		this.removeChildren();
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/display/SpriteButton.ts